export enum TaskStatus {
  Outstanding = 0,
  Completed = 1,
}
